<template>
  <div class="view" id="login">

    <div class="box" v-if="!forgotPassMode">
      <div class="content">

      <input type="text" v-model="login_user" placeholder="User">
      <input type="password" v-model="login_pwd" placeholder="Password">

      <div class="grid">
        <div class="col m50">
          <btn @click.native="forgotPassMode=true" block>Glemt kodeord?</btn>
        </div>
        <div class="col m50">
          <btn @click.native="doLogin()" color="2" full>Log ind</btn>
        </div>
      </div>

      </div>
    </div>

    <box label="Log ind" v-if="forgotPassMode">
      <div class="field">
        <label>Email</label>
        <input type="text" v-model="password_reset_email" placeholder="Email">
      </div>

      <div class="btn half left" @click="forgotPassMode=false">
      <div class="fa fa-angle-left"></div> Tilbage
      </div>

      <div class="btn a half right" _@click="resetPassword">
      <div class="fa fa-angle-right"></div>
      Nyt pass plz
      </div>
    </box>


  </div>
</template>

<script>
import globals from './../globals.js'
import auth from './../auth.js';
import Box from '.././components/Box'
import Btn from '.././components/Btn'
export default {
  name: 'login',
  data: function () {
    return {
      globals: this.$parent.globals,
      forgotPassMode: false,
      login_pwd: undefined,
      login_user: undefined,
      password_reset_email: undefined,
    }
  },
  methods: {
    doLogin(){
      // validate email, etc
      //console.log(this.login_user)
      //console.log(this.login_pwd)
      auth.login( this.login_user, this.login_pwd )
    },
    forgotPass(){

    },
  },
  components: { Box, Btn, },
}
</script>



// WEBPACK FOOTER //
// Login.vue?6232ffd4